import { render, staticRenderFns } from "./CalendarDay.vue?vue&type=template&id=2230dfc8&"
import script from "./CalendarDay.vue?vue&type=script&lang=ts&"
export * from "./CalendarDay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports